export default __webpack_public_path__ + "static/media/ogi.1ed16980.jpeg";